import React, { useEffect, useState } from 'react'
import { Col, Form, ProgressBar, Row } from 'react-bootstrap'
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa'

const PasswordStrengthMeter = ({ password }) => {
  const [passwordStrength, setPasswordStrength] = useState(0)
  const [passwordRequirements, setPasswordRequirements] = useState({})

  const evaluatePasswordStrength = (password) => {
    let strength = 0
    const requirements = {
      length: false,
      uppercase: false,
      numberOrSpecialChar: false,
    }

    // Check length
    if (password.length >= 8) {
      strength++
      requirements.length = true
    }

    // Check for uppercase letters
    if (/[A-Z]/.test(password)) {
      strength++
      requirements.uppercase = true
    }

    // Check for numbers or special characters
    if (/\d/.test(password) || /[^A-Za-z0-9]/.test(password)) {
      strength++
      requirements.numberOrSpecialChar = true
    }

    return { strength, requirements }
  }

  useEffect(() => {
    const evaluation = evaluatePasswordStrength(password)
    setPasswordStrength(evaluation.strength)
    setPasswordRequirements(evaluation.requirements)
  }, [password])

  const getPasswordStrengthVariant = () => {
    switch (passwordStrength) {
      case 1:
        return 'danger'
      case 2:
        return 'warning'
      default:
      case 3:
        return 'success'
    }
  }

  const renderRequirement = (requirement, label) => (
    <Col sm={6} style={{ display: 'flex', alignItems: 'center' }}>
      {requirement ? <FaCheckCircle color='green' /> : <FaTimesCircle color='red' />}
      <span style={{ textDecoration: requirement ? 'line-through' : 'none', marginLeft: '8px' }}>{label}</span>
    </Col>
  )

  return (
    <>
      <ProgressBar
        now={passwordStrength * 33.33}
        variant={getPasswordStrengthVariant()}
        className='my-2'
        style={{ height: '4px' }}
      />
      <Form.Text className='text-muted'>
        <Row>
          {renderRequirement(passwordRequirements.length, 'Min 8 characters')}
          {renderRequirement(passwordRequirements.uppercase, '1 uppercase letter')}
          {renderRequirement(passwordRequirements.numberOrSpecialChar, '1 number or special character')}
        </Row>
      </Form.Text>
    </>
  )
}

export default PasswordStrengthMeter
